import React, { useMemo, useState } from 'react';
import { X, Plus, Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

export default function CreateTaskModal({ onClose, onCreated, companyOptions = [], assigneeSuggestions = [] }) {
  const { isAdmin } = useAuth();
  const [form, setForm] = useState({
    title: '',
    assigned_by: '',
    priority: 'medium',
    description: '',
    visibility: 'public',
    deadline: '',
    status: 'new',
    task_company: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const datalistId = useMemo(() => `assignee-suggest-${Math.random().toString(36).slice(2, 8)}`, []);

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.title.trim() || !form.assigned_by.trim()) {
      setError('Title và Người giao task là bắt buộc');
      return;
    }

    setLoading(true);
    try {
      const payload = { ...form };
      if (!payload.deadline) delete payload.deadline;
      if (!payload.task_company) delete payload.task_company;
      await api.createTask(payload);
      onCreated?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-md" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Tạo Task mới</div>
          <button className="btn-icon" onClick={onClose} type="button"><X size={18} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="alert alert-error">{error}</div>}

            <div className="form-group">
              <label className="form-label">Title Task *</label>
              <input className="form-input" value={form.title} onChange={(e) => handleChange('title', e.target.value)} placeholder="Nhập tiêu đề task..." autoFocus required />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Người giao task *</label>
                <input
                  className="form-input"
                  value={form.assigned_by}
                  onChange={(e) => handleChange('assigned_by', e.target.value)}
                  placeholder="Tên người giao"
                  list={datalistId}
                  required
                />
                <datalist id={datalistId}>
                  {assigneeSuggestions.map((name) => <option key={name} value={name} />)}
                </datalist>
                <div className="form-hint">Có gợi ý theo tên user đã tạo trong hệ thống.</div>
              </div>
              <div className="form-group">
                <label className="form-label">Độ ưu tiên</label>
                <select className="form-select" value={form.priority} onChange={(e) => handleChange('priority', e.target.value)}>
                  <option value="high">Cao</option>
                  <option value="medium">Trung bình</option>
                  <option value="low">Thấp</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Mô tả</label>
              <textarea className="form-textarea" rows={4} value={form.description} onChange={(e) => handleChange('description', e.target.value)} placeholder="Mô tả chi tiết task..." />
            </div>

            <div className="form-row form-row-3">
              <div className="form-group">
                <label className="form-label">Chế độ hiển thị</label>
                <select className="form-select" value={form.visibility} onChange={(e) => handleChange('visibility', e.target.value)}>
                  <option value="public">Public - Ai cũng xem được</option>
                  <option value="internal">Internal - Cần đăng nhập</option>
                  {isAdmin && <option value="private">Private - Chỉ Admin</option>}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Cột</label>
                <select className="form-select" value={form.status} onChange={(e) => handleChange('status', e.target.value)}>
                  <option value="new">Mới</option>
                  <option value="in_progress">Đang làm</option>
                  <option value="on_hold">Đang treo</option>
                  <option value="in_review">Đang Review</option>
                  <option value="done">Đã xong</option>
                  <option value="cancelled">Huỷ</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Task thuộc công ty</label>
                <div className="input-with-icon">
                  <Building2 size={15} />
                  <select className="form-select" value={form.task_company} onChange={(e) => handleChange('task_company', e.target.value)}>
                    <option value="">Không chọn</option>
                    {companyOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Deadline (GMT+7)</label>
              <input type="datetime-local" className="form-input" value={form.deadline} onChange={(e) => handleChange('deadline', e.target.value)} />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-ghost" type="button" onClick={onClose}>Huỷ</button>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              <Plus size={15} /> {loading ? 'Đang tạo...' : 'Tạo Task'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
